import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21",
  viewBox: "0 0 21 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "m10.5 15.75-6.1717 3.2447 1.1787-6.8724-4.9931-4.867 6.9002-1.0026L10.5 0z"
      }),
      _createElementVNode("path", {
        fill: "#000",
        style: {"opacity":"0.2"},
        d: "m10.5138 15.75 6.1717 3.2447-1.1787-6.8724 4.9931-4.867-6.9002-1.0026L10.5138 0z"
      })
    ], -1)
  ])))
}
export default { render: render }